import React from "react";
import { Chevron } from "./icons";
import { BAND, RED, gutter, picture } from "./look";

export const LineBreak = () => <div style={{ height: 10, background: BAND }} />;

export function Title({ name, icon, viewAll = false }) {
  return (
    <div className="d-flex align-items-center justify-content-between" style={{ ...gutter, marginTop: 15, marginBottom: 15 }}>
      <div className="d-flex align-items-center" style={{ minWidth: 0 }}>
        {icon && <img src={picture(icon)} alt="" style={{ width: 30, height: 30, marginRight: 10, objectFit: "cover" }} />}
        <span style={{ fontSize: 16, fontWeight: 700, lineHeight: 1.3 }}>{name}</span>
      </div>
      {viewAll && (
        <span className="d-flex align-items-center" style={{ color: RED, fontSize: 14, fontWeight: 500, whiteSpace: "nowrap" }}>
          <span>View all</span>
          <Chevron />
        </span>
      )}
    </div>
  );
}
